/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * stores the height and width of the window
 */

// for test cases, when the window object is not defined
if (typeof window !== 'object') {
    window = {
        innerHeight: 789,
        innerWidth: 1440,
    };
}

var windowScreenWidth = window.innerHeight;
var windowScreenHeight = window.innerHeight;

var windowData = {};
if (windowScreenWidth !== undefined) {
    windowData.width = windowScreenWidth;
}
if (windowScreenHeight !== undefined) {
    windowData.height = windowScreenHeight;
}

module.exports = windowData;
